import { Controller } from '@hotwired/stimulus';

const ON_CLASS = 'translate-x-5';
const OFF_CLASS = 'translate-x-0';

export default class extends Controller {
  static targets = ['button', 'child', 'wrapper'];

  connect() {
    this.restoreState();

    this.colorize();
  }

  toggle() {
    this.innerSpan.classList.toggle(ON_CLASS);
    this.innerSpan.classList.toggle(OFF_CLASS);

    this.colorize();
    this.saveState();
  }

  on() {
    this.innerSpan.classList.replace(OFF_CLASS, ON_CLASS);

    this.colorize();
    this.saveState();
  }

  off() {
    this.innerSpan.classList.replace(ON_CLASS, OFF_CLASS);

    this.colorize();
    this.saveState();
  }

  colorize() {
    this.childTargets.forEach((div) => {
      if (this.isOn) {
        if (div.dataset.colorizerClass)
          div.classList.add(...div.dataset.colorizerClass.split(' '));
        if (div.dataset.colorizerStyle)
          div.style.cssText = div.dataset.colorizerStyle;
      } else {
        if (div.dataset.colorizerClass)
          div.classList.remove(...div.dataset.colorizerClass.split(' '));
        if (div.dataset.colorizerStyle) div.style.cssText = '';
      }
    });
  }

  saveState() {
    const state = this.isOn ? 'on' : 'off';
    localStorage.setItem('colorizer', state);
  }

  restoreState() {
    if (this.wrapperTarget.classList.contains('hidden')) {
      this.on();
      return;
    }

    const state = localStorage.getItem('colorizer');
    if (!state) return;

    if ((state === 'on') !== this.isOn) this.toggle();
  }

  get isOn() {
    return this.innerSpan.classList.contains(ON_CLASS);
  }

  get innerSpan() {
    return this.buttonTarget.querySelector('span');
  }
}
